import {
  GOT_INVOICE,
  GET_INVOICE,
  GET_POS_SETTINGS,
  GOT_POS_SETTINGS,
  GOT_GIFTCERT_SETTING,
  CREATE_INVOICE,
  CREATED_INVOICE,
  UPDATED_DISCOUNT_MENU_VISIBILITY,
  UPDATED_CHECKOUT_MODE,
  UPDATED_PAYMENT_MODE,
  UPDATED_CHECKOUT_APPOINTMENT_STEP_DATA,
  UPDATED_TIP_POPUP_VISIBILITY,
  CHANGE_UPDATE_INVOICE_TO_BOOKING,
  UPDATE_INVOICE,
  UPDATED_INVOICE,
  UPDATE_BOOKING_TO_INVOICE,
  UPDATED_BOOKING_TO_INVOICE,
  GET_BOOKING_PAYMENTS,
  GOT_BOOKING_PAYMENTS,
  REFUND_INVOICE_PAYMENT,
  REFUNDED_INVOICE_PAYMENT,
  CHARGE_EXISTING_CARD,
  CHARGED_EXISTING_CARD,
  UPDATE_GETTING_STRIPE_TOKEN,
  UPDATED_SHARE_INVOICE_VISIBILITY,
  GET_INVOICE_PDF,
  GOT_INVOICE_PDF,
  FIND_GIFT_CERTIFICATE,
  FOUND_GIFT_CERTIFICATE,
  REMOVE_GIFT_CERTIFICATE,
  REDEEM_GIFT_CERTIFICATE,
  REDEEMED_GIFT_CERTIFICATE,
  UPDATE_INVOICE_AFTER_PAYMENT,
  UPDATE_GIFT_CERT_SALE_FORM_VISIBILITY,
  CREATE_GIFT_CERTIFICATE,
  CREATED_GIFT_CERTIFICATE,
  ADD_KEY_TO_GIFT_CERT_VALUE_LIST,
  GET_GIFT_CERTIFICATE,
  GOT_GIFT_CERTIFICATE,
  PAYMENT_SETTING_SUCCESS,
  GET_PAYMENT_SETTING
} from "../actions/checkoutAppointmentStep";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";
import {
  GOT_EXISTING_BOOKING,
  SAVED_BOOKING_FORM,
  GOT_PURCHASED_OFFER
} from "../actions/booking";
import { checkoutAppointmentStepInitialState } from "../state/initialState";
import objectAssign from "object-assign";
import { clone } from "./helper";
import { decimalPoint } from "../utils/helpers";

export default (state = checkoutAppointmentStepInitialState, action) => {
  let newStatus;
  let newCheckoutStepData;
  switch (action.type) {
    case GET_INVOICE:
      newStatus = {
        gettingInvoice: true
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_GLOBAL_ERROR_MESSAGE:
      newStatus = {
        gettingInvoicePdf: false,
        updatingInvoice: false,
        creatingInvoice: false,
        gettingInvoice: false,
        gettingPosSettings: false,
        updatingBookingToInvoice: false,
        updatingBookingPayments: false,
        gettingGiftCertificate: false,
        redeemingGiftCertificate: false,
        creatingGiftCertificate: false
      };
      return objectAssign({}, state, newStatus);
    case GOT_INVOICE:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.paymentAmount = decimalPoint(
        action.data.outstandingamount
      );
      newCheckoutStepData.removeExistingGiftCertData = true;
      newStatus = {
        gettingInvoice: false,
        invoiceData: action.data,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_CHECKOUT_MODE:
      newStatus = {
        checkoutMode: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_DISCOUNT_MENU_VISIBILITY:
      newStatus = {
        discountMenuVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_GETTING_STRIPE_TOKEN:
      newStatus = {
        isGettingStripeToken: action.isGettingStripeToken
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_PAYMENT_MODE:
      newStatus = {
        paymentMode: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_CHECKOUT_APPOINTMENT_STEP_DATA:
      return objectAssign({}, state, {
        checkoutAppointmentStepData: action.data
      });
    case GET_POS_SETTINGS:
      newStatus = {
        gettingPosSettings: true
      };
      return objectAssign({}, state, newStatus);
    case GOT_POS_SETTINGS:
      newStatus = {
        posSettings: action.data,
        gettingPosSettings: false
      };
      return objectAssign({}, state, newStatus);
    case GOT_GIFTCERT_SETTING:
      newStatus = {
        giftCertSetting: action.data
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_TIP_POPUP_VISIBILITY:
      return objectAssign({}, state, { tipPopupVisible: action.data });
    case UPDATED_SHARE_INVOICE_VISIBILITY:
      return objectAssign({}, state, {
        shareInvoiceVisible: action.shareInvoiceVisible
      });
    case CHANGE_UPDATE_INVOICE_TO_BOOKING:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.shouldUpdateInvoiceToBooking = action.data;
      newStatus = {
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case CREATE_INVOICE:
      newStatus = {
        creatingInvoice: true
      };
      return objectAssign({}, state, newStatus);
    case CREATED_INVOICE:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.invoiceKey = action.data.key;
      newCheckoutStepData.paymentAmount = decimalPoint(
        action.data.outstandingamount
      );
      newCheckoutStepData.removeExistingGiftCertData = true;
      newStatus = {
        creatingInvoice: false,
        invoiceData: action.data,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case SAVED_BOOKING_FORM:
    case GOT_EXISTING_BOOKING:
      newStatus = clone(state.checkoutAppointmentStepData);
      let mergedData = objectAssign(
        {},
        newStatus,
        action.data.checkoutAppointmentStepData
      );
      let modifiedState = objectAssign({}, state, {
        checkoutAppointmentStepData: mergedData
      });
      return modifiedState;
    case UPDATE_INVOICE:
      newStatus = {
        updatingInvoice: true
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_INVOICE:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.isEditingServicePrice = false;
      newCheckoutStepData.paymentAmount = decimalPoint(
        action.data.outstandingamount
      );
      newCheckoutStepData.removeExistingGiftCertData = true;
      newStatus = {
        updatingInvoice: false,
        invoiceData: action.data,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_BOOKING_TO_INVOICE:
      newStatus = {
        updatingBookingToInvoice: true
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_BOOKING_TO_INVOICE:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.updateInvoiceAfterPayment = true;
      newCheckoutStepData.haveDownloadDataAfterCashOrGiftPayment = false;
      newStatus = {
        updatingBookingToInvoice: false,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case REFUND_INVOICE_PAYMENT:
    case CHARGE_EXISTING_CARD:
    case GET_BOOKING_PAYMENTS:
      newStatus = {
        updatingBookingPayments: true
      };
      return objectAssign({}, state, newStatus);
    case REFUNDED_INVOICE_PAYMENT:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.paymentAmount = decimalPoint(
        action.data.invoice.outstandingamount
      );
      newCheckoutStepData.didDoRefund = true;
      newCheckoutStepData.removeExistingGiftCertData = true;
      newStatus = {
        updatingBookingPayments: false,
        bookingPaymentsData: action.data,
        invoiceData: action.data.invoice,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case CHARGED_EXISTING_CARD:
    case GOT_BOOKING_PAYMENTS:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);

      if (action.data.invoice && action.data.invoice.outstandingamount)
        newCheckoutStepData.paymentAmount = decimalPoint(
          action.data.invoice.outstandingamount
        );
      newCheckoutStepData.removeExistingGiftCertData = true;
      newStatus = {
        updatingBookingPayments: false,
        bookingPaymentsData: action.data,
        invoiceData: action.data.invoice || {},
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case GET_INVOICE_PDF:
      newStatus = {
        gettingInvoicePdf: true
      };
      return objectAssign({}, state, newStatus);
    case GOT_INVOICE_PDF:
      newStatus = {
        gettingInvoicePdf: false,
        invoicePdfData: action.data
      };
      return objectAssign({}, state, newStatus);
    case FIND_GIFT_CERTIFICATE:
      newStatus = {
        gettingGiftCertificate: true
      };
      return objectAssign({}, state, newStatus);
    case FOUND_GIFT_CERTIFICATE:
      let giftCertData = action.data;
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      if (giftCertData) {
        const giftCertBalance = giftCertData.balance;
        if (giftCertBalance > 0 && state.invoiceData.outstandingamount > 0) {
          newCheckoutStepData.giftCertRedemptionAmount = decimalPoint(
            Math.min(giftCertBalance, state.invoiceData.outstandingamount)
          );
        }
      }
      newStatus = {
        gettingGiftCertificate: false,
        foundGiftCertData: giftCertData,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case REMOVE_GIFT_CERTIFICATE:
      newStatus = {
        foundGiftCertData: null
      };
      return objectAssign({}, state, newStatus);
    case REDEEM_GIFT_CERTIFICATE:
      newStatus = {
        redeemingGiftCertificate: true
      };
      return objectAssign({}, state, newStatus);
    case REDEEMED_GIFT_CERTIFICATE:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.updateInvoiceAfterPayment = true;
      newCheckoutStepData.haveDownloadDataAfterCashOrGiftPayment = false;
      newStatus = {
        redeemingGiftCertificate: false,
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case GET_GIFT_CERTIFICATE:
    case CREATE_GIFT_CERTIFICATE:
      newStatus = {
        creatingGiftCertificate: true
      };
      return objectAssign({}, state, newStatus);
    case GOT_GIFT_CERTIFICATE:
    case CREATED_GIFT_CERTIFICATE:
      let newGiftCertKey = action.data.key;
      let newGiftCertValue = action.data.value;
      let createGiftCertValueList = state.giftCertValueList.filter(giftCert => {
        return giftCert.key != newGiftCertKey;
      });
      createGiftCertValueList.push({
        key: newGiftCertKey,
        value: newGiftCertValue
      });
      newStatus = {
        creatingGiftCertificate: false,
        giftCertValueList: createGiftCertValueList
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_INVOICE_AFTER_PAYMENT:
      newCheckoutStepData = clone(state.checkoutAppointmentStepData);
      newCheckoutStepData.isNewPriceLessThanInvoicePaid =
        action.data.isNewPriceLessThanInvoicePaid;
      newStatus = {
        checkoutAppointmentStepData: newCheckoutStepData
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_GIFT_CERT_SALE_FORM_VISIBILITY:
      newStatus = {
        giftCertSaleFormVisible: action.data
      };
      return objectAssign({}, state, newStatus);
    case ADD_KEY_TO_GIFT_CERT_VALUE_LIST:
      let newGiftCertValueList = state.giftCertValueList.filter(giftCert => {
        return giftCert.key != action.data;
      });
      newGiftCertValueList.push({ key: action.data });
      newStatus = {
        creatingGiftCertificate: true,
        giftCertValueList: newGiftCertValueList
      };
      return objectAssign({}, state, newStatus);
    case GET_PAYMENT_SETTING:
      return {
        ...state,
        paymentSetting: {
          ...state.paymentSetting,
          loading: true
        }
      };
    case PAYMENT_SETTING_SUCCESS:
      return {
        ...state,
        paymentSetting: {
          ...action.data,
          loading: false
        }
      };
    default:
      return state;
  }
  return state;
};
